<template>
    <div class="w-[100vw] h-[100vh] fixed top-0 left-0 flex justify-center items-center bg-[#0000005a]">
        <div class="w-[40vw]  text-white gap-4 p-4 bg-[#5D5D98] rounded-[10px]  flex flex-col">
            <div class="w-full flex gap-2 justify-between items-center">
                <h3 class="text-[#ff9b05]">Filtro</h3>
                <div class="flex gap-2 items-center">

                    <AppButton class=" text-white" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl"
                        emitType="close" @close="close" :width="23" :height="23" />
                </div>
            </div>

            <div class="flex gap-2 items-center ">
                <label class=" min-w-[6.5rem] ">Data Fim:</label>
                <!-- <input v-if="edit_mode" :disabled="true" type="text" v-model="item_proposta.equipamento.nome"
                    class="text-white text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-96"> -->
                <input type="date" v-model="data_fim"
                    class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full">
                <button :style="{ color: 'red' }" @click="remove('data_fim')">
                    <i class="fa-regular fa-circle-xmark text-2xl"></i>
                </button>
            </div>

            <div class="flex gap-2 items-center ">
                <label class=" min-w-[6.5rem] ">Distrito:</label>
                <!-- <input v-if="edit_mode" :disabled="true" type="text" v-model="item_proposta.equipamento.nome"
                    class="text-white text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-96"> -->
                <input :disabled="true" type="text" v-model="distrito_concat"
                    class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full">
                <button class="fa-solid fa-pen-to-square text-2xl " :style="{ color: '#ff9b05' }"
                    @click="open_dialog_alert('distrito')"></button>
                <button :style="{ color: 'red' }"  @click="remove('distrito')">
                        <i class="fa-regular fa-circle-xmark text-2xl"></i>
                </button>
            </div>

            <div class="flex gap-2 items-center">
                <label class=" min-w-[6.5rem]">Concelho:</label>
                <!-- <input v-if="edit_mode" :disabled="true" type="text" v-model="item_proposta.equipamento.nome"
                    class="text-white text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-96"> -->
                <input :disabled="true" type="text" v-model="concelho_concat"
                    class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full">
                <button class="fa-solid fa-pen-to-square text-2xl "
                    :style="{ color: distritos.length == 0 ? 'gray' : '#ff9b05' }"
                    @click="open_dialog_alert('concelho')"></button>
                <button :style="{ color: 'red' }"  @click="remove('concelho')">
                        <i class="fa-regular fa-circle-xmark text-2xl"></i>
                </button>
            </div>

            <div class="flex gap-2 items-center">
                <label class=" min-w-[6.5rem]">Freguesia:</label>
                <!-- <input v-if="edit_mode" :disabled="true" type="text" v-model="item_proposta.equipamento.nome"
                    class="text-white text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-96"> -->
                <input :disabled="true" type="text" v-model="freguesia_concat"
                    class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full">
                <button class="fa-solid fa-pen-to-square text-2xl "
                    :style="{ color: concelhos.length == 0 ? 'gray' : '#ff9b05' }"
                    @click="open_dialog_alert('freguesia')"></button>
                <button :style="{ color: 'red' }"  @click="remove('freguesia')">
                        <i class="fa-regular fa-circle-xmark text-2xl"></i>
                </button>
            </div>

            <div class="flex gap-2 items-center">
                <label class=" min-w-[6.5rem] text-nowrap">Codigo Postal:</label>
                <!-- <input v-if="edit_mode" :disabled="true" type="text" v-model="item_proposta.equipamento.nome"
                    class="text-white text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-96"> -->
                <input :disabled="true" type="text" v-model="codigo_postal_concat"
                    class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full">
                <button class="fa-solid fa-pen-to-square text-2xl "
                    :style="{ color: freguesias.length == 0 ? 'gray' : '#ff9b05' }"
                    @click="open_dialog_alert('codigo_postal')"></button>
                <button :style="{ color: 'red' }" @click="remove('codigo_postal')">
                    <i class="fa-regular fa-circle-xmark text-2xl"></i>
                </button>
            </div>

            <div class="flex gap-2 items-center">
                <label class=" min-w-[6.5rem]">Familia:</label>
                <!-- <input v-if="edit_mode" :disabled="true" type="text" v-model="item_proposta.equipamento.nome"
                    class="text-white text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-96"> -->
                <input :disabled="true" type="text" v-model="familia_concat"
                    class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full">
                <button class="fa-solid fa-pen-to-square text-2xl " :style="{ color: '#ff9b05' }"
                    @click="open_dialog_alert('familia')"></button>
                <button :style="{ color: 'red' }" @click="remove('familia')">
                    <i class="fa-regular fa-circle-xmark text-2xl"></i>
                </button>
            </div>

            <div class="flex gap-2 items-center">
                <label class=" min-w-[6.5rem]">Zona:</label>
                <input :disabled="true" type="text" v-model="zona_concat"
                    class="text-black text-[16px] border-1 border-[#ccc] p-1 rounded-[5px] w-full">
                <button class="fa-solid fa-pen-to-square text-2xl " :style="{ color: '#ff9b05' }"
                    @click="open_dialog_alert('zona')"></button>

                <button :style="{ color: 'red' }" @click="remove('zona')">
                    <i class="fa-regular fa-circle-xmark text-2xl"></i>
                </button>
            </div>

            <div class=" flex gap-4 mt-4">

                <AppButton :padding="'var(--padding_btn)'" class="capitalize mb-auto" v-bind:visibility="true"
                    :font_size="12" color="#ff9b05" left_icon="fa-solid fa-pen-to-square" text="Confirmar"
                    emitType="select" @select="salvar_filtro" />

                <AppButton :padding="'var(--padding_btn)'" class="capitalize mb-auto" v-bind:visibility="true"
                    :font_size="12" color="red" left_icon="fa-regular fa-rectangle-xmark" text="Cancelar"
                    emitType="select" @select="close" />
            </div>

        </div>
    </div>

    <Dialog v-if="showDialog" :propsData="dialogProps" @close="closeDialog" @returnData="handleReturnData"
        :pagination="true" :multiSelectOptions="multiSelectOptions" />


</template>


<script>
import AppButton from '@/components/updated/button.vue'
import Dialog from '@/components/dialog/dinamicDialog.vue'
import { toast } from "vue3-toastify";

export default {
    components: {
        AppButton,
        Dialog
    },
    data() {
        return {
            distritos: [],
            concelhos: [],
            freguesias: [],
            codigos_postais: [],
            familias: [],

            zona: {
                id: '',
                nome: '',
            },

            data_fim: '',
            distrito_concat: '',
            concelho_concat: '',
            freguesia_concat: '',
            codigo_postal_concat: '',
            familia_concat: '',
            zona_concat: '',
            currentType: null,
            dialogProps: {
                entity: ['equipamento', 'tpiva', 'tpmoeda'],
                sideBar: true,
                multi: false,
                queryParams: { 'equipamento': 'custom=1&tpmarca_id=1' },
            },
            showDialog: false,
            currentType: '',
            multiSelectOptions: {
                enabled: true,
                show_btn: false
            },


        }
    },
    methods: {
        close() {
            this.$emit('close')
        },

        open_dialog_alert(key) {
            if (key == "zona") {
                this.multiSelectOptions.enabled = false;
                this.dialogProps.entity[0] = "tpzona";
                this.currentType = "tpzona";
                this.dialogProps.title = "zona";
                this.showDialog = true;
            }
            else if (key == 'distrito') {
                this.multiSelectOptions.enabled = true;
                this.dialogProps.entity[0] = "distrito";
                this.currentType = "distrito";
                this.dialogProps.title = "distrito";
                this.showDialog = true;
            }
            else if (key == 'concelho') {
                this.multiSelectOptions.enabled = true;
                if (this.distritos.length == 0) {

                    return;
                }
                this.dialogProps.entity[0] = "concelho/distrito/" + this.distritos.map(item => item.dd).join(',') + "";
                this.dialogProps.title = "concelho";
                this.currentType = "concelho";
                this.showDialog = true;
            }
            else if (key == 'freguesia') {
                this.multiSelectOptions.enabled = true;
                if (this.concelhos.length == 0) {
                    return;
                }

                this.dialogProps.entity[0] = "freguesia/distrito/" + this.distritos.map(item => item.dd).join(',') + "/concelho/" + this.concelhos.map(item => item.cc).join(',') + "";
                this.currentType = "freguesia";
                this.dialogProps.title = "freguesia";

                this.showDialog = true;
            }
            else if (key == 'codigo_postal') {
                this.multiSelectOptions.enabled = true;
                if (this.freguesias.length == 0) {
                    return;
                }
                this.dialogProps.entity[0] = "locart/distrito/" + this.distritos.map(item => item.dd).join(',') +
                    "/concelho/" + this.concelhos.map(item => item.cc).join(',') + "/freguesia/" + this.freguesias.map(item => item.ff).join(',') + "";
                this.currentType = "codigo_postal";
                this.dialogProps.title = "codigoPostal";

                this.showDialog = true;
            }
            else if (key == 'familia') {
                this.multiSelectOptions.enabled = true;
                this.dialogProps.entity[0] = "familia";
                this.currentType = "familia";
                this.dialogProps.title = "familia";

                this.showDialog = true;
            }

            // this.$emit('open_dialog_alert',key)
        },

        handleReturnData(data) {
            console.log("Returned data:", data);

            if (data.zona) {
                if (Array.isArray(data.tpzona)) {
                    this.zona_concat = data.zona.map(item => item.nome).join(', ');
                }
                else {

                    this.zona.nome = data.zona.nome;
                    this.zona.id = data.zona.id;
                    this.zona_concat = data.zona.nome;
                }
            }
            else if (data.distrito) {
                if (Array.isArray(data.distrito)) {
                    this.distritos = data.distrito;
                    this.distrito_concat = data.distrito.map(item => item.distrito).join(', ');
                }
                else {
                    this.distrito_concat = data.distrito.distrito;
                    this.distritos = [data.distrito];
                }
            }
            else if (data.concelho) {
                if (Array.isArray(data.concelho)) {
                    this.concelhos = data.concelho;
                    this.concelho_concat = data.concelho.map(item => item.concelho).join(', ');
                }
                else {
                    this.concelho_concat = data.concelho.concelho;
                    this.concelhos = [data.concelho];
                }
            }
            else if (data.freguesia) {
                if (Array.isArray(data.freguesia)) {
                    this.freguesias = data.freguesia;
                    this.freguesia_concat = data.freguesia.map(item => item.freguesia).join(', ');
                }
                else {
                    this.freguesia_concat = data.freguesia.freguesia;
                    this.freguesias = [data.freguesia];
                }
            }
            else if (data.codigoPostal) {
                if (Array.isArray(data.codigoPostal)) {
                    this.codigos_postais = data.codigoPostal;
                    this.codigo_postal_concat = data.codigoPostal.map(item => item.cp4 + '-' + item.cp3).join(', ');
                }
                else {
                    this.codigo_postal_concat = data.codigoPostal.cp4 + '-' + data.codigoPostal.cp3;
                    this.codigos_postais = [data.codigoPostal];
                }
            }
            else if (data.familia) {
                if (Array.isArray(data.familia)) {
                    this.familias = data.familia;
                    this.familia_concat = data.familia.map(item => item.nome).join(', ');
                }
                else {
                    this.familia_concat = data.familia.nome;
                    this.familias = [data.familia];
                }
            }
        },
        closeDialog() {
            this.showDialog = false;
        },

        salvar_filtro() {
            if(this.zona_concat == '' ){
                toast("Preencha o campo Zona!", {
                    "theme": "auto",
                    "type": "warning",
                    "position": "top-center",
                    "autoClose": 1000,
                });
                return;
            }
            const final_data = {
                distritos: this.distritos,
                concelhos: this.concelhos,
                freguesias: this.freguesias,
                codigos_postais: this.codigos_postais,
                familias: this.familias,
                zona: this.zona,
                utilizador: this.tecnico.id!=0? this.tecnico : {},
                data_fim: this.data_fim,

            }
            this.$emit('confirm', final_data);
        },

        remove(key) {
            if (key == 'familia') {
                this.familias = [];
                this.familia_concat = '';
            }
            else if (key == 'zona') {
                this.zona = {
                    id: '',
                    nome: '',
                }
                this.zona_concat = '';
            }
            else if (key == 'distrito') {
                this.distritos = [];
                this.distrito_concat = '';
                this.concelhos = [];
                this.concelho_concat = '';
                this.freguesias = [];
                this.freguesia_concat = '';
                this.codigos_postais = [];
                this.codigo_postal_concat = '';

            }
            else if (key == 'concelho') {
                this.concelhos = [];
                this.concelho_concat = '';
                this.freguesias = [];
                this.freguesia_concat = '';
                this.codigos_postais = [];
                this.codigo_postal_concat = '';

            }
            else if (key == 'freguesia') {
                this.freguesias = [];
                this.freguesia_concat = '';
                this.codigos_postais = [];
                this.codigo_postal_concat = '';

            }
            else if (key == 'codigo_postal') {
                this.codigos_postais = [];
                this.codigo_postal_concat = '';

            }

            else if (key == 'data_fim') {
                this.data_fim = '';
            }
        }

    },
    mounted() {

    },
    props: {
        data: {
            type: Object,
            default: () => { }
        },
        tecnico: {
            type: Object,
            default: () => { }
        }

    },
    watch: {
        data: {
            handler(val) {
                console.log(val);
                if (val.distritos) {
                    this.distritos = val.distritos;
                    this.distrito_concat = val.distritos.map(item => item.distrito).join(', ');
                }
                if (val.concelhos) {
                    this.concelhos = val.concelhos;
                    this.concelho_concat = val.concelhos.map(item => item.concelho).join(', ');
                }
                if (val.freguesias) {
                    this.freguesias = val.freguesias;
                    this.freguesia_concat = val.freguesias.map(item => item.freguesia).join(', ');
                }
                if (val.codigos_postais) {
                    this.codigos_postais = val.codigos_postais;
                    this.codigo_postal_concat = val.codigos_postais.map(item => item.cp4 + '-' + item.cp3).join(', ');
                }
                if (val.familias) {
                    this.familias = val.familias;
                    this.familia_concat = val.familias.map(item => item.nome).join(', ');
                }
                if (val.zona) {
                    this.zona = val.zona;
                    this.zona_concat = val.zona.nome;
                }
                if (val.data_fim) {
                    this.data_fim = val.data_fim;
                }
            },
            immediate: true,
            deep: true
        },
        
    }

}



</script>




<style scoped></style>